import { atom } from 'recoil';

const BOT_FILTER_KEY = 'sf_bot_filter';

// localStorage effect for boolean value
const localStorageEffect = (key) => ({ setSelf, onSet }) => {
  const savedValue = localStorage.getItem(key);
  if (savedValue != null) {
    setSelf(savedValue === 'true');
  }
  onSet((newValue, _, isReset) => {
    if (isReset) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, String(newValue));
    }
  });
};

// Bot filter state - filters out suspected bot traffic from analytics
export const botFilterAtom = atom({
  key: 'botFilter',
  default: false,
  effects: [localStorageEffect(BOT_FILTER_KEY)],
});
